import React from 'react';
import WhyChooseVallenAI from './WhyChooseVallenAI';

const OurCommitment = () => {
  return (
    <section className="startup-commitment-section py-5" style={{
      background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
      padding: '6rem 0'
    }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div style={{
              background: 'white',
              border: '1px solid #e2e8f0',
              borderRadius: '24px',
              padding: '3rem',
              textAlign: 'center',
              position: 'relative',
              overflow: 'hidden',
              boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)'
            }}>
              {/* Background Pattern */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: `
                  radial-gradient(circle at 20% 80%, rgba(14, 165, 233, 0.1) 0%, transparent 50%),
                  radial-gradient(circle at 80% 20%, rgba(59, 130, 246, 0.08) 0%, transparent 50%)
                `,
                zIndex: 1
              }}></div>

              <div style={{ position: 'relative', zIndex: 2 }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  background: 'linear-gradient(135deg, #0ea5e9 0%, #0ea5e9 100%)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 2rem',
                  boxShadow: '0 4px 15px rgba(14, 165, 233, 0.2)'
                }}>
                  <i className="bi bi-shield-check" style={{
                    fontSize: '2rem',
                    color: 'white'
                  }}></i>
                </div>

                <h2 style={{
                  fontSize: 'clamp(1.8rem, 3vw, 2.5rem)',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '1rem'
                }}>
                  Our Commitment to Your Success
                </h2>
                
                <p style={{
                  fontSize: '1.1rem',
                  color: '#64748b',
                  lineHeight: '1.6',
                  marginBottom: '2rem',
                  maxWidth: '800px',
                  margin: '0 auto 2rem'
                }}>
                  At <strong style={{ color: '#0ea5e9' }}>Vallen AI</strong>, we understand the importance of building lasting partnerships. As a startup, we bring fresh perspectives, innovative approaches, and personal attention to every project. We're not just service providers - we're your technology partner committed to your long-term success.
                </p>

                <div className="row g-4 justify-content-center">
                  <div className="col-md-6 col-lg-3">
                    <div style={{
                      background: 'rgba(255, 255, 255, 0.8)',
                      borderRadius: '16px',
                      padding: '2rem',
                      border: '1px solid rgba(14, 165, 233, 0.2)',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between'
                    }}>
                      <div style={{
                        width: '50px',
                        height: '50px',
                        background: 'linear-gradient(135deg, #0ea5e9 0%, #0ea5e9 100%)',
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 1rem'
                      }}>
                        <i className="bi bi-headset" style={{
                          fontSize: '1.5rem',
                          color: 'white'
                        }}></i>
                      </div>
                      <h4 style={{
                        fontSize: '1.2rem',
                        fontWeight: '700',
                        color: '#1e293b',
                        marginBottom: '0.5rem'
                      }}>
                        Full Support Included
                      </h4>
                      <p style={{
                        fontSize: '1rem',
                        color: '#64748b',
                        lineHeight: '1.5'
                      }}>
                        Every solution comes with comprehensive support and maintenance. We're here 24/7 to ensure your success.
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-3">
                    <div style={{
                      background: 'rgba(255, 255, 255, 0.8)',
                      borderRadius: '16px',
                      padding: '2rem',
                      border: '1px solid rgba(139, 92, 246, 0.2)',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between'
                    }}>
                      <div style={{
                        width: '50px',
                        height: '50px',
                        background: 'linear-gradient(135deg, #0ea5e9 0%, #0ea5e9 100%)',
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 1rem'
                      }}>
                        <i className="bi bi-people" style={{
                          fontSize: '1.5rem',
                          color: 'white'
                        }}></i>
                      </div>
                      <h4 style={{
                        fontSize: '1.2rem',
                        fontWeight: '700',
                        color: '#1e293b',
                        marginBottom: '0.5rem'
                      }}>
                        Permanent Partnership
                      </h4>
                      <p style={{
                        fontSize: '1rem',
                        color: '#64748b',
                        lineHeight: '1.5'
                      }}>
                        We become your long-term technology partner, not just a one-time vendor. Your success is our success.
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-3">
                    <div style={{
                      background: 'rgba(255, 255, 255, 0.8)',
                      borderRadius: '16px',
                      padding: '2rem',
                      border: '1px solid rgba(16, 185, 129, 0.2)',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between'
                    }}>
                      <div style={{
                        width: '50px',
                        height: '50px',
                        background: 'linear-gradient(135deg, #0ea5e9 0%, #0ea5e9 100%)',
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 1rem'
                      }}>
                        <i className="bi bi-arrow-clockwise" style={{
                          fontSize: '1.5rem',
                          color: 'white'
                        }}></i>
                      </div>
                      <h4 style={{
                        fontSize: '1.2rem',
                        fontWeight: '700',
                        color: '#1e293b',
                        marginBottom: '0.5rem'
                      }}>
                        Money-Back Guarantee
                      </h4>
                      <p style={{
                        fontSize: '1rem',
                        color: '#64748b',
                        lineHeight: '1.5'
                      }}>
                        If we don't meet your requirements, we'll refund your payment. Your satisfaction is guaranteed.
                      </p>
                    </div>
                  </div>
                </div>

                <WhyChooseVallenAI 
                  benefits={[
                    {
                      icon: "bi-graph-up-arrow",
                      title: "Business Impact Delivery",
                      description: "We deliver measurable business value with AI solutions that directly impact your bottom line and operational efficiency."
                    },
                    {
                      icon: "bi-clock-history",
                      title: "24/7 Availability & Support",
                      description: "Round-the-clock support with unlimited free revisions and deep industrial AI project experience across multiple sectors."
                    },
                    {
                      icon: "bi-database",
                      title: "Data Centric AI Approach",
                      description: "Our data-first methodology ensures your AI solutions are built on solid foundations with clean, validated, and optimized datasets."
                    },
                    {
                      icon: "bi-shield-check",
                      title: "Money Back Guarantee",
                      description: "100% risk-free investment with our comprehensive money-back guarantee if we don't meet your specified requirements."
                    }
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurCommitment;
